import React from 'react';
import { HiArrowNarrowRight } from 'react-icons/hi';
import resume from '../assets/resume.pdf'

const Home = () => {
  return (
    <div name='home' className='w-full h-screen bg-[#0a192f]'>
      {/* Container */}
      <div className='max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full'>
        <p className='text-green-200 text-2xl'>Hi, I am</p>
        <h1 className='text-4xl sm:text-7xl font-bold text-[#ccd6f6]'>
          Chowdhury Tafsir Ahmed Siddiki
        </h1>
        <h2 className='text-4xl sm:text-5xl text-[#8892b0]'>
          MERN Stack Developer.
        </h2>
        <p className='text-[#8892b0] py-4 max-w-[700px]'>
          I’m a mern stack developer specializing in building exceptional web applications. Currently, I’m focused on building responsive full-stack web applications. But in future my dream is to start working with blockchain development, web 3.0 etc.
        </p>
        <div>
          <button className='text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-pink-600 hover:border-pink-600'>
            <a href={resume} target='_blank'>My Resume</a>
            <span className='group-hover:rotate-90 duration-300'>
              <HiArrowNarrowRight className='ml-3 ' />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
